<div class="replace-matcard">
  <h1 class="cursorDefault">{{variant?.title}}</h1>
  <div>
    <mat-form-field class="margin-right w-350">
      <mat-label>{{variant?.dropdownPlaceholder}}</mat-label>
      <mat-select disableOptionCentering="true" (selectionChange)="changeWagon($event.value)" [(value)]="selectedWagon">
        <mat-option class="select-without-checkbox" *ngFor="let wagon of wagons" [value]="wagon.id">
          {{wagon.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button [disabled]="selectedWagon?.id < 1" class="margin-left color"
      (click)="createVariantDialog()">
      <mat-icon class="add">add_box</mat-icon>{{variant?.addButton}}
    </button>
  </div>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource">

      <!-- variantName Column -->
      <ng-container matColumnDef="variantName">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{variant?.col1Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop" title="{{element.name}}">{{element.name}}</span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="variantActions">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{variant?.col2Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <mat-icon class="openCell" title="{{variant?.action1}}" (click)="editVariant(element.id)">edit</mat-icon>
          <mat-icon class="delete" title="{{variant?.action3}}" (click)="showDeleteDialog(element.id)">
            cancel</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row-effect"></tr>
    </table>
  </div>
</div>
<hr class="line">